<template>
    <section class="pt-4 animated fadeIn">
        <div class="px-4">
            <div class="row">
                <div class="col-lg-8 right-side-form">
                    <div class="continue-booking mb-4">
                        <div class="booking-header px-5 py-3">
                            <h5>Who’s traveling?</h5>
                        </div>
                        <hr class="my-0">
                        <div class="px-5 mt-4 pb-4">
                            <div class="booking-notification-header justify-content-center d-flex align-items-center">
                                <img src="@/assets/TAJimages/flight/info-icon.svg" alt="info-icon">
                                <p class="ml-2 booking-notification-text">Use all given names and surnames exactly as they appear on your passport/ID to avoid complications.</p>
                            </div>
                        </div>
                    </div>
                    <form @submit.prevent="continueBooking">
                      <!-- Adults  -->
                    <div v-for="(data, index) in numberOfAdults" :key="index" class="mt-4 pb-2 continue-booking pl-5 pr-3 py-4">
                      <div class="d-flex justify-content-between">
                        <h4 class="booking-pass-text">Adult {{ index + 1 }}  - Primary Contact</h4>
                        <img src="@/assets/TAJimages/flight/arrow-d-icon.svg" style="cursor: pointer;" @click="collapsedPart(index, 'adults')" alt="arrow"/>
                      </div>
                      <div :class="collapsedPartIds.find((i) => i === index) !== undefined ? 'hide_form': 'animated fadeIn'" >
                        <passengerForm :id="index" :adult="true" :submit="submitNewForm" @new-data="submitPassengerForm"/>
                      </div>
                    </div>
                    <!-- children  -->
                    <div v-for="(data, index) in numberOfChildren" :key="index + 2" class="mt-4 pb-2 continue-booking pl-5 pr-3 py-4">
                      <div class="d-flex justify-content-between">
                        <h4 class="booking-pass-text">Child {{ index + 1 }} - Primary Contact</h4>
                        <img src="@/assets/TAJimages/flight/arrow-d-icon.svg" style="cursor: pointer;" @click="collapsedPart(index, 'children')" alt="arrow"/>
                      </div>
                      <div :class="collapsedChildren.find((i) => i === index) !== undefined ? 'hide_form': 'animated fadeIn'" >
                        <passengerForm :id="index + 3" :child="true" :submit="submitNewForm" @new-data="submitPassengerForm"/>
                      </div>
                    </div>
                    <!-- infants  -->
                    <div v-for="(data, index) in numberOfInfants" :key="index + 12" class="mt-4 pb-2 continue-booking pl-5 pr-3 py-4">
                      <div class="d-flex justify-content-between">
                        <h4 class="booking-pass-text">Infant {{ index + 1 }} - Primary Contact</h4>
                        <img src="@/assets/TAJimages/flight/arrow-d-icon.svg" style="cursor: pointer;" @click="collapsedPart(index, 'infants')" alt="arrow"/>
                      </div>
                      <div :class="collapsedInfants.find((i) => i === index) !== undefined ? 'hide_form': 'animated fadeIn'" >
                        <passengerForm :id="index + 12" :Infant="true" :submit="submitNewForm" @new-data="submitPassengerForm"/>
                      </div>
                    </div>
                    <!-- information  -->
                    <div class="continue-booking mt-4 mb-4 py-3 px-4">
                      <h5 class="booking-pass-text mb-3">Where should we send your confirmation?</h5>
                      <div class="row">
                          <div class="col-lg-6 form-group">
                              <label class="form-label">Email <span class="text-danger">*</span></label>
                              <input type="text" v-model="details.email" class="form-control" required placeholder="Enter Email">
                          </div>
                          <div class="col-lg-6 form-group">
                              <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                              <div class="d-flex">
                                <select class="form-control" disabled style="width:90px;">
                                  <option value="+234">+234</option>
                                </select>
                                <input type="text" v-model="details.phoneNumber" @keypress="isNumber" required minlength="10" maxlength="10" class="form-control" placeholder="8123456778">
                              </div>
                          </div>
                      </div>
                    </div>
                    <!-- promo section  -->
                    <div class="continue-booking mt-4 mb-4">
                        <div class="d-flex align-items-center justify-content-between py-3 pl-5 pr-3">
                            <h5 class="booking-pass-text">Membership Card Number/ Promo Code</h5>
                            <img src="@/assets/TAJimages/flight/arrow-d-icon.svg" style="cursor: pointer;" @click="showDropdown('memberPromo')" alt="srrow">
                        </div>
                        <div class="form-group px-5 pb-4 animated fadeIn" v-if="showMemberPromo">
                            <label for="code" class="form-label">Enter Promo Code</label>
                            <input type="text" class="form-control" placeholder="Enter Promo Code">
                        </div>
                    </div>
                    <div class="continue-booking mt-4">
                        <div class="d-flex align-items-center justify-content-between py-3 pl-5 pr-3">
                            <h5 class="booking-pass-text">Corporate Code</h5>
                            <img src="@/assets/TAJimages/flight/arrow-d-icon.svg" style="cursor: pointer;" @click="showDropdown('corporatePromo')" alt="arrow">
                        </div>
                        <div class="form-group px-5 pb-3 animated fadeIn" v-if="showCorporatePromo">
                            <label for="code" class="form-label">Enter Promo Code</label>
                            <input type="text" class="form-control" placeholder="Enter Promo Code ">
                        </div>
                    </div>
                    <div class="continue-booking mt-4 mb-5">
                        <div class="d-flex align-items-center justify-content-between py-3 pl-5 pr-3">
                            <h5 class="booking-pass-text">Terms and Conditions</h5>
                            <img src="@/assets/TAJimages/flight/arrow-d-icon.svg" style="cursor: pointer;" @click="showDropdown('terms')" alt="arrow">
                        </div>
                        <div class="form-group px-5 pb-3 animated fadeIn" v-if="showTerms" style="height: 400px; overflow:scroll">
                          <div class="text-dark d-flex align-items-start" v-for="(terms, index) in termsAndCondition" :key="index">
                              <span class="mr-3">{{index + 1}}.</span><p v-html="terms"></p>
                            </div>
                        </div>
                    </div>
                    <div class="pb-5">
                        <div>
                            <input type="checkbox" v-model="checked" class="mr-2" value="check"/>By proceeding, I acknowledge that I have read and agree to the Flight booking <span class="text-danger" style="cursor:pointer" @click="showTerms = true">terms & conditions</span>
                        </div>
                        <div class="d-flex mt-4 justify-content-start align-items-center text-center">
                            <p @click="proceed" class="text-danger mr-5 mb-0 font-weight-bold" style="cursor:pointer">Back</p>
                            <button type="submit" :disabled="loading" class="btn btn-danger">
                                <div v-if="loading">Please wait...</div> 
                                <div v-else>Continue</div> 
                            </button>
                        </div>
                    </div>
                    </form>
                </div>
                <div class="col-lg-4 right-side-form">
                    <div class="continue-booking">
                        <div class="p-4">
                            <div class="departure" v-for="(info, i) in flightMainInfo" :key="i">
                                <p class="p-text">Depart <span class="sub-p-text ml-2">{{info.departureTime | momentDate}} . {{info.stops}} stop</span></p>
                                <div class="d-flex justify-content-between align-items-center">
                                    <p class="sub-p-text">{{info.departureTime | dayjs}} <span class="p-text">({{info.departureCode}})</span></p>
                                    <div>
                                        <img src="@/assets/TAJimages/flight/plane-icon.svg" alt="arrow">
                                    </div>
                                    <p class="sub-p-text">{{info.arrivalTime | dayjs}} <span class="p-text">({{info.arrivalCode}})</span></p>
                                </div>
                                <div class="d-flex justify-content-between mt-2" v-for="(item, j) in info.flightLegs" :key="j">
                                    <div>
                                        <p class="sub-p-text">{{item.departureName}}</p>
                                        <!-- <p class="sub-p-text">{{item.departureCode}}</p> -->
                                    </div>
                                    
                                    <div class="text-right">
                                        <p class="sub-p-text">{{item.destinationName}}</p>
                                        <p class="arrives-text">Arrives on {{info.arrivalTime | momentDate}}</p>
                                        <!-- <p class="sub-p-text">London</p> -->
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4">
                            <div class="mt-3" v-for="(price, k) in getFlightPriceDetails" :key="k + 4">
                                <p class="p-text pb-1">Flight Base Fare</p>
                                <p class="sub-p-text">{{price.passengerType}}</p>
                                <div class="d-flex justify-content-between mt-2">
                                    <div>
                                        <p class="sub-p-text">Base Fare</p>
                                        <p class="sub-p-text">Tax</p>
                                    </div>
                                    <div class="text-right">
                                        <p class="p-text">N{{new Intl.NumberFormat('en-NG', {}).format(price.baseFare.amount)}}</p>
                                        <p class="p-text">N{{new Intl.NumberFormat('en-NG', {}).format(price.tax.amount)}}</p>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="total-sec d-flex justify-content-between">
                                <h5>Total:</h5>
                                <h6>N{{new Intl.NumberFormat('en-NG', {}).format(flightPrice.amount)}}</h6>
                            </div>
                        </div>
                        <div class="footer-sec">
                            <p>Price may increase if you book later.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import { decrypt } from '@/_services/encryption';
  import { mapActions, mapState } from 'vuex';
  import moment from 'moment';
  import dayjs from 'dayjs';
  import passengerForm from '@/components/passengerForm.vue';
  export default {
    components: {
        passengerForm
    },
    filters: {
      dayjs: function (date) {
        return dayjs(date).format('hh:mma');
      },
      momentDate: function (date) {
        return moment(date).format('DD MMM, YYYY');
      }
    },
    data:() => ({
      collapsedPartIds: [],
      collapsedChildren: [],
      collapsedInfants: [],
      isFormOpen: false,
      tabItems: 'itinerary',
      step: 1,
      isOtpPage: 1,
      showMemberPromo: false,
      showCorporatePromo: false,
      showTerms: false,
      isLoading: false,
      passengerDetails: [],
      bookingItemModels: [],
      submitNewForm: false,
      details: {
        email: '',
        phoneNumber: ''
      },
      form: {
        title: '',
        passengerType: '',
        firstName: '',
        lastName: '',
        middleName: '',
        dateOfBirth: '',
        age: '',
        phoneNumber: '',
        address: '',
        passportNumber: '',
        expiryDate: '',
        email: '',
        gender: '',
        city: '',
        country: '',
        postalCode: '',
        passportIssuingAuthority: ''
      },
      bookingDetails: {
        bookingId: '',
        targetCurrency: 'NGN',
        bookingData: '',
        productType: 'Flight',
      },
      checked: false,
      loading: false,
      submitForm: {
        accountNumber: '',
        pnrNumber: '',
        bookingId: '',
        appPlatform: 1,
        transactionReference: '',
        transactionPin: '',
      },
      type: 'password',
      value: 'nextStep',
      updatedPassengerDetails: []
    }),
    computed: {
      ...mapState('flight', ['selectedFlight']),
      ...mapState({
        account: state => state.dashboard.dashboardData,
      }),
      flightModel() {
        return this.selectedFlight ? this.selectedFlight.flightSummaryModel : {};
      },
      flightDetails() {
        return this.flightModel ? this.flightModel.flightCombination : {};
      },
      flightPrice() {
        return this.flightDetails ? this.flightDetails.price : {};
      },
      flightMainInfo() {
        return this.flightDetails ? this.flightDetails.flightModels : [];
      },
      getFlightPriceDetails() {
        return this.flightDetails ? this.flightDetails.priceDetails : {};
      },
      numberOfAdults () {
        return this.flightDetails.adults
      },
      numberOfChildren () {
        return this.flightDetails.children
      },
      numberOfInfants () {
        return this.flightDetails.infants
      },
      termsAndCondition () {
        return this.selectedFlight ? this.selectedFlight.productTermsAndConditions.termsAndConditions : []
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions('flight', ['getSelectedFlight', 'bookFlight', 'payForFlight']),
      getAge(dateString) {
        var ageInMilliseconds = new Date() - new Date(dateString);
        return Math.floor(ageInMilliseconds/1000/60/60/24/365); // convert to years
      },
      getPassengerAge() {
        this.passengerDetails.forEach((data) => {
          data.age = this.getAge(data.dateOfBirth)
        })
      },
      setPassengerType () {
        this.getPassengerAge()
        this.updatedPassengerDetails = this.passengerDetails.map((d) => {
          return {
            ...d,
            ...this.details,
            passengerType: d.age > 12 ? 'Adult' : d.age >= 2 && d.age <= 12 ? 'Child' : d.age < 2 ? 'Infant' : ''
          }
        })
      },
      submitPassengerForm (form) {
        this.passengerDetails.push(form)
      },
      collapsedPart(id, type) {
        switch (type) {
          case 'adults':
            if (this.collapsedPartIds.find((i) => i === id) !== undefined) {
              this.collapsedPartIds = this.collapsedPartIds.filter((i) => i !== id)
            } else this.collapsedPartIds = [...this.collapsedPartIds, id]
            break;
          case 'children':
            if (this.collapsedChildren.find((i) => i === id) !== undefined) {
              this.collapsedChildren = this.collapsedChildren.filter((i) => i !== id)
            } else this.collapsedChildren = [...this.collapsedChildren, id]
            break;
          case 'infants':
              if (this.collapsedInfants.find((i) => i === id) !== undefined) {
                this.collapsedInfants = this.collapsedInfants.filter((i) => i !== id)
              } else this.collapsedInfants = [...this.collapsedInfants, id]
          break;
        }
      },
      proceed() {
        this.$emit('goBack')
      },
      nextPage() {
        this.$emit('nextStep')
      },
      showDropdown(type) {
        switch (type) {
        case 'memberPromo':
          this.showMemberPromo = !this.showMemberPromo;
          break;
        case 'corporatePromo':
          this.showCorporatePromo =  !this.showCorporatePromo;
          break;
        case 'terms':
          this.showTerms =  !this.showTerms;
          break;
        }
      },
      async continueBooking() {
        this.submitNewForm = true
        setTimeout(() => {
          this.setPassengerType()
        }, 100);
        this.bookingDetails.bookingId = this.selectedFlight.bookingId;
        this.bookingDetails.bookingData = this.selectedFlight.selectData;
        this.bookingItemModels.push(this.bookingDetails);
        const models = this.bookingItemModels.length > 0 ? [this.bookingItemModels[0]] : this.bookingItemModels
        if(this.checked) {
          this.loading = true;
          setTimeout(async () => {
            const data = {
              passengerDetails: this.updatedPassengerDetails,
              bookingItemModels: models,
              bookingId: this.selectedFlight.bookingId,
            };
            try {
            const response = await this.bookFlight(data);
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            this.loading = false;
            this.nextPage();
            const details = userParseData.flightBookingResult.flightBookingSummaryModel;
            const newData = {
                pnrNumber: details.pnrReferenceNumber,
                bookingId: userParseData.bookingId
            }
            this.$store.commit('flight/SET_BOOKING_DATA', newData)
          } catch (error) {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title:'Oops...',
              text: objError.errors[0],
              type:'error'
            });
            }
          }, 1000);
          
        } else {
          this.$swal({
            title: 'Oops...',
            text: 'Please agree to the terms and conditions',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
      }
    }
  };
</script>

<style scoped>
  .hide_form {
    height: 0px;
    overflow: hidden;
}
.search-body {
  height: 100%;
  padding: 0 30px;
  margin: 0;
  background-color: #EAF0F3;
}
.view__header {
    background: #EAF0F3;
    height: 100%;
    padding-top: 40px;
    padding-bottom: 10px;
}
.view__header--text {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-weight: bold;
    font-size: 15px;
}
.notification-header {
    padding: 10px;
    background: #D4EDDA 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 789px;
}
.notification-text {
    letter-spacing: 0.3px;
    color: #155724;
    opacity: 1;
    margin-bottom: 0;
}
.tab-section {
    height: 42px;
    background: #E1ECF3 0% 0% no-repeat padding-box;
    opacity: 1;
}
.tab-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    width: 350px;
    margin: 0 auto;
    cursor: pointer;
}
.tab-items h5 {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 16px;
    font-weight: 500;
}
.tab-items h5:last-child {
    color: #818F9B;
}
.tab__section {
    padding: 10px 50px;
}
.right-side {
    height: 500px;
    overflow: scroll;
}
.right-side-form {
    height: 700px;
    overflow: scroll;
}
.line {
    height: 1px;
    background: #E1ECF3;
    border: 1px dotted #E1ECF3;
    width: 90%;
    margin: 10px 0px;
}
.line-1 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #6D757D;
    margin: 20px 0px;
}
.line-2 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #E1ECF3;
    margin: 20px 0px;
}
.departure-header {
    letter-spacing: 0.4px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.fare-summary {
    width: 375px;
    height: 100%;
    background: #223344 0% 0% no-repeat padding-box;
    opacity: 1;
    /* position: fixed; */
}
.flight-luggage {
    background: #FDF9EC 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 20px;
    width: 90%;
}
.flight-luggage p {
    letter-spacing: 0.34px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
}
.flight-about-date {
    letter-spacing: 0.34px;
    color: #818F9B;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.airport-name {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
    font-weight: normal;
    width: 387px;
}
.flight-type {
    letter-spacing: 0.3px;
    color: #818F9B;
    opacity: 1;
    font-size: 13px;
    font-weight: normal;
}
.flight-time {
    letter-spacing: 0.34px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.traveler-text h5,
.trav-amount {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.traveler-text h6 {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.rules h6 {
    letter-spacing: 0.36px;
    color: #3A4248;
    opacity: 1;
    font-size: 18px;
}
.rules p {
    letter-spacing: 0.24px;
    color: #3A4248;
    opacity: 1;
    font-size: 13px;
    font-weight: normal;
}
.sub-text {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
}
.continue-booking {
    background: #FFFFFF;
    opacity: 1;
}
.booking-header h5 {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 17px;
    font-weight: bold;
}
.booking-notification-header {
    background: #F2F2FF 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 10px 15px;
}
.booking-notification-text {
    letter-spacing: 0.3px;
    color: #6569B5;
    opacity: 1;
    margin-bottom: 0;
    font-size: 11px;
}
.booking-pass-text {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.fa-angle-down {
    cursor: pointer;
}
input::placeholder,
textarea::placeholder,
option {
    font-size: 14px;
    color: #ACACAC;
    font-weight: 400;
}
.p-text {
    letter-spacing: 0.28px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: bold;
}
.sub-p-text {
    letter-spacing: 0.28px;
    color: #6D8494;
    opacity: 1;
    font-weight: normal;
    font-size: 13px;
    margin-bottom: 4px;
}
.arrives-text {
    letter-spacing: 0.28px;
    font-size: 13px;
    margin-bottom: 0;
    color: #E41613;
}
.total-sec h5 {
    letter-spacing: 0px;
    color: #6D8494;
    opacity: 1;
    font-size: 18px;
}
.total-sec h6 {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 18px;
}
.footer-sec {
    background: #FFF0E4;
    padding: 15px 20px;
    text-align: center;
    color: #223344;
    opacity: 1;
}
.footer-sec p {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
}
.details-section {
    /* padding: 40rem 0; */
    padding-top: 5rem;
}
.payment-header {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    margin-bottom: 0;
    font-size: 18px;
}
.border-sm {
    border-radius: 7px;
}
.otpPage p {
    letter-spacing: -0.18px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
}
.otpPage h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
}
.succes-page h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
    margin-top: 50px;
}
.succes-page p {
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
    margin-top: 30px;
    margin-bottom: 60px;
}
.active-border {
    border-bottom: 2px solid #F58220;
}
.show-pin {
  font-size: 12px;
  color: #E41613;
  cursor: pointer;
}
</style>